import { EntityTypes } from "./enums";

export interface SourcingRequestMatchV2 {
  requestId: string;
  matchId: string;
  entityType: EntityTypes.sourcingRequestMatch;
  orgName: string;
  orgId: string;
  industry: string;
  location: string;
  website: string;
  contactPerson?: string;
  yearsInBusiness?: string;
  certifications?: string;
  overallScore: number;
  categoryScores: Record<string, number>;
  strengths: string[];
  gaps: string[];
  confidenceLevel: string;
  recommendation: string;
  created: number;
  lastUpdated: number;
}

export interface CreateSourcingRequestMatchV2Input {
  requestId: string;
  orgName: string;
  orgId: string;
  industry: string;
  location: string;
  website: string;
  contactPerson?: string;
  yearsInBusiness?: string;
  certifications?: string;
  overallScore: number;
  categoryScores: Record<string, number>;
  strengths: string[];
  gaps: string[];
  confidenceLevel: string;
  recommendation: string;
}